import React from 'react';
import { SlideContent } from '../components/canvas/SlideContent';
import { SlideFooter } from '../components/canvas/SlideFooter';
import { SlideLogo } from '../components/canvas/SlideLogo';
import { NudgeableGroup } from '../components/canvas/NudgeableGroup';

/**
 * Ribbon Band layout — announcement/event style.
 * Horizontal dark strip spanning full width. Content centered in the strip.
 * Footer pinned at bottom for cross-template consistency.
 */
export function RibbonBandLayout({ data, fontPreset, logoEnabled = true, logoUrl = null, logoSize = null, logoIsDark = false, pc }) {
  return (
    <div className="absolute inset-0 flex flex-col">
      {/* Top area */}
      <div className="flex-1 min-h-[80px] flex items-start justify-between px-[72px] pt-[72px]">
        {/* Accent line */}
        <div className="flex-1">
          <div
            className="h-[3px] w-[140px] rounded-full"
            style={{
              background: `linear-gradient(90deg, ${pc.accent(0.80)} 0%, ${pc.accentSoft(0.60)} 100%)`,
            }}
          />
        </div>
        {/* Logo */}
        {logoEnabled && (
          <NudgeableGroup groupId="logo">
            <SlideLogo className="h-12 w-12" style={{ color: pc.text(0.50) }} logoUrl={logoUrl} size={logoSize} isDark={logoIsDark} />
          </NudgeableGroup>
        )}
      </div>

      {/* Content band */}
      <NudgeableGroup
        groupId="content"
        className="px-[72px] py-[48px]"
        style={{ backgroundColor: pc.surfaceAt(0.60) }}
      >
        <SlideContent
          data={data}
          fontPreset={fontPreset}
          pc={pc}
          options={{
            showFooter: false,
            mutedOpacity: 0.70,
            subtleOpacity: 0.45,
          }}
        />
      </NudgeableGroup>

      {/* Bottom area */}
      <div className="flex-1 min-h-[60px]" />

      {/* Footer — pinned at bottom */}
      <div className="absolute bottom-[64px] left-[64px] right-[64px]">
        <SlideFooter data={data} pc={pc} />
      </div>
    </div>
  );
}
